import { Controller } from "@hotwired/stimulus"
import Chart from "chart.js/auto"

// Connects to data-controller="admin-dashboard"
export default class extends Controller {
  static targets = ["activityChart", "kpiCount", "sparkline"]

  connect() {
    this.animateKpiCounts()
    this.drawMainChart()
    this.drawSparklines()
  }

  animateKpiCounts() {
    if (!this.hasKpiCountTarget) return

    this.kpiCountTargets.forEach(el => {
      const finalValue = parseInt(el.dataset.count, 10)
      let current = 0
      const step = Math.ceil(finalValue / 50) || 1

      const interval = setInterval(() => {
        current += step
        if (current >= finalValue) {
          el.innerText = finalValue
          clearInterval(interval)
        } else {
          el.innerText = current
        }
      }, 15)
    })
  }

  drawMainChart() {
    if (!this.hasActivityChartTarget) return

    const ctx = this.activityChartTarget
    const enquiriesData = JSON.parse(ctx.dataset.enquiries)
    const reservationsData = JSON.parse(ctx.dataset.reservations)
    const labels = JSON.parse(ctx.dataset.labels)

    const gradientEnquiries = ctx.getContext("2d").createLinearGradient(0, 0, 0, 400)
    gradientEnquiries.addColorStop(0, "rgba(78,115,223,0.5)")
    gradientEnquiries.addColorStop(1, "rgba(78,115,223,0)")

    const gradientReservations = ctx.getContext("2d").createLinearGradient(0, 0, 0, 400)
    gradientReservations.addColorStop(0, "rgba(255,193,7,0.5)")
    gradientReservations.addColorStop(1, "rgba(255,193,7,0)")

    new Chart(ctx, {
      type: "line",
      data: {
        labels: labels,
        datasets: [
          {
            label: "Enquiries",
            data: enquiriesData,
            borderColor: "#4e73df",
            backgroundColor: gradientEnquiries,
            fill: true,
            tension: 0.3,
            pointRadius: 4,
            pointHoverRadius: 6
          },
          {
            label: "Reservations",
            data: reservationsData,
            borderColor: "#ffc107",
            backgroundColor: gradientReservations,
            fill: true,
            tension: 0.3,
            pointRadius: 4,
            pointHoverRadius: 6
          }
        ]
      },
      options: {
        responsive: true,
        plugins: {
          legend: { display: true, position: "bottom" },
          tooltip: { mode: "index", intersect: false }
        },
        scales: {
          y: { beginAtZero: true },
          x: { grid: { display: false } }
        }
      }
    })
  }

  drawSparklines() {
    if (!this.hasSparklineTarget) return

    this.sparklineTargets.forEach(el => {
      const data = JSON.parse(el.dataset.values)
      new Chart(el, {
        type: "line",
        data: { labels: data.map((_, i) => i + 1), datasets: [{ data, borderColor: "#4e73df", fill: false, tension: 0.3, pointRadius: 0 }] },
        options: { responsive: true, plugins: { legend: { display: false } }, scales: { x: { display: false }, y: { display: false } } }
      })
    })
  }
}
